const Ideas = () => import(/* webpackChunkName: "Ideas" */ "@/views/ideas/Ideas");
const General = () => import(/* webpackChunkName: "Ideas General" */ "@/views/ideas/IdeasGeneral");
const Stats = () => import(/* webpackChunkName: "Ideas Stats" */ "@/views/ideas/IdeasStats");
const Top = () => import(/* webpackChunkName: "Ideas Top" */ "@/views/ideas/topIdeas/IdeasTop");
const IdeasList = () => import(/* webpackChunkName: "Ideas List" */ "@/views/ideas/topIdeas/IdeasList");
const IdeasEdit = () => import(/* webpackChunkName: "Ideas Edit" */ "@/views/ideas/topIdeas/IdeasEdit");
const Campaign = () => import(/* webpackChunkName: "Ideas Campaign" */ "@/views/ideas/campaign/IdeasCampaign");
const CampaignList = () => import(/* webpackChunkName: "Campaign List" */ "@/views/ideas/campaign/CampaignList");
const CampaignNew = () => import(/* webpackChunkName: "Campaign Edit" */ "@/views/ideas/campaign/CampaignNew");
const Points = () => import(/* webpackChunkName: "Points" */ "@/views/ideas/points/Points");
const PointsScore = () => import(/* webpackChunkName: "Points Score" */ "@/views/ideas/points/PointsScore");
const PointsRedeem = () => import(/* webpackChunkName: "Points Redeem" */ "@/views/ideas/points/PointsRedeem");
// const Status = () => import(/* webpackChunkName: "Ideas Status" */ "@/views/ideas/IdeasStatus");
const Rewards = () => import(/* webpackChunkName: "Ideas Rewards" */ "@/views/ideas/IdeasRewards");

const ideasRoutes = [
  {
    path: "ideas",
    name: "Ideas",
    redirect: {
      name: "Ideas General"
    },
    component: Ideas,
    children: [
      {
        path: "general",
        name: "Ideas General",
        component: General
      },
      {
        path: "stats",
        name: "Ideas Stats",
        component: Stats
      },
      {
        path: "top",
        name: "Ideas Top",
        redirect: {
          name: "Ideas List"
        },
        component: Top,
        children: [
          {
            path: "list",
            name: "Ideas List",
            component: IdeasList
          },
          {
            path: "edit/:id",
            name: "Ideas Edit",
            component: IdeasEdit,
            props: true
          }
        ]
      },
      {
        path: "campaign",
        name: "Ideas Campaign",
        redirect: {
          name: "Campaign List"
        },
        component: Campaign,
        children: [
          {
            path: "list",
            name: "Campaign List",
            component: CampaignList
          },
          {
            path: "new",
            name: "Campaign New",
            component: CampaignNew
          },
          {
            path: "edit/:id",
            name: "Campaign Edit",
            component: CampaignNew,
            props: true
          }
        ]
      },
      {
        path: "points",
        name: "Ideas Points",
        redirect: {
          name: "Points Score"
        },
        component: Points,
        children: [
          {
            path: "score",
            name: "Points Score",
            component: PointsScore
          },
          {
            path: "redeem",
            name: "Points Redeem",
            component: PointsRedeem
          }
        ]
      },
      // {
      //   path: "status",
      //   name: "Ideas Status",
      //   component: Status
      // },
      {
        path: "rewards",
        name: "Ideas Rewards",
        component: Rewards
      }
    ]
  }
];

export default ideasRoutes;